































import mixins from 'vue-typed-mixins';
import DashboardUtils from '@/utils/DashboardUtils';
import SurveyUtils, { SurveyParticipation } from '@/utils/SurveyUtils';
import { DataTableHeader } from 'vuetify';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<SurveyParticipation>[] {
      return [
        { 
          text: this.$tc('model.survey.label'),
          value: 'survey.name.public'
        },
        {
          text: this.$tc('model.serviceProvider.label'),
          value: 'serviceprovider.name'
        },
        {
          text: this.$tc('model.surveyState.label'),
          value: 'submissionstate.name',
        },
        {
          text: this.$tc('model.common.dueDate'),
          value: 'survey.duedate',
        },
      ];
    },
  },

  data(): {
    participations?: SurveyParticipation[];
  } {
    return {
      participations: undefined,
    };
  },

  async mounted() {
    try {
      this.participations = await DashboardUtils.serviceProvider();
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {},
});
